import React, { useState } from 'react';
import {Button, Upload} from 'antd';
import {UploadFile} from "antd/es/upload/interface";
import {UploadChangeParam} from "antd/lib/upload";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {PreviewImage} from "../preview-image/preview-image";
import {notifications} from "../../../services/notifications/notifications";

export interface FileUploaderProps<T> {
    upload: (file: File) => Promise<T>;
    fileList: CustomUploadFile[];
    onFileListChanged: (value: CustomUploadFile[]) => void;
    onRemove?: (value: CustomUploadFile) => Promise<any>;
    maxCount?: number;
    disableUpload?: boolean;
}

export interface CustomUploadFile extends UploadFile {
}

export interface Response {
    id: number;
    filename: string;
    url: string;
}

export const FileUploader = <T extends Response>({fileList, onFileListChanged, onRemove, upload, maxCount, disableUpload}: FileUploaderProps<T>) => {

    const [previewFile, setPreviewFile] = useState<UploadFile<T>|null>(null);

    const onUploadChange = (event: UploadChangeParam<UploadFile<T>>) => {

        if (event.file.response) {
            const resp = event.file.response;
            const newFile: CustomUploadFile | undefined = event.fileList.find(file => file.uid === event.file.uid);
            if (newFile) {
                newFile.url = resp.url;
                newFile.fileName = resp.filename;
                newFile.uid = resp.id.toString();
            }
        }

        onFileListChanged(event.fileList);
    };

    const onPreview = (file: CustomUploadFile): any => {
        setPreviewFile(file);
    };

    const closePreview = (): any => {
        setPreviewFile(null);
    };

    const onRemoveWrapped = (value: CustomUploadFile): Promise<any> => {
        if (value.status === "removed" || value.status === "error" || !onRemove) {
            return Promise.resolve();
        }

        return onRemove(value);
    }

    return (
        <>
            <Upload
                maxCount={maxCount}
                customRequest={async (options: any) => {
                    try {
                        options.onProgress({percent: 10});
                        options.onSuccess(await upload(options.file as File));
                    } catch (e: any) {
                        if (!e?.response?.data?.messages) {
                            const message = e?.response?.data?.fields?.[0]?.errors?.[0] ?? 'Unknown error';
                            notifications.message('error', message)
                        }
                        options.onError();
                    }
                }}
                listType="picture-card"
                fileList={fileList}
                onChange={onUploadChange}
                onPreview={onPreview}
                onRemove={onRemoveWrapped}
                showUploadList={{
                    showDownloadIcon: true,
                    showPreviewIcon: true,
                    showRemoveIcon: true,
                }}
            >
                {disableUpload ? null : (
                    <Button type={"text"} icon={<FontAwesomeIcon icon={["fas", "upload"]} />}>Upload</Button>
                )}
            </Upload>
            {!!previewFile ? (
                <PreviewImage
                    onClose={closePreview}
                    title={previewFile?.name || ''}
                    url={previewFile?.url || ''}
                />
            ) : null}
        </>
    );
};